<template>
    <app-page-content>
        <app-sub-title text="Reporte de Gestión Mensual" />
        <app-filters @filter="loadReportData" />
        <div class v-if="!!reportSections.length">
            <div class="d-flex justify-content-center">
                <img src="/images/bitacorapp-logo.png" alt />
            </div>

            <div class="location-date d-flex flex-column mb-5">
                <span class="location-date__city" v-if="!!clientCity"
                    >{{ clientCity.name }} - {{ currentDate }}</span
                >
                <span class="location-date__client">
                    {{ selectedClient.name }}
                </span>
                <span class="location-date__complement">Ciudad</span>
            </div>

            <app-monthly-management-report-section
                :section="getSection('referencia')"
            ></app-monthly-management-report-section>

            <app-monthly-management-report-section
                :section="getSection('visitas-peatonales')"
            >
                <app-pie-chart :chart-data="reportData.personEntriesData" />
            </app-monthly-management-report-section>

            <div class="page-break">
                <app-monthly-management-report-section
                    :section="getSection('visitas-vehiculares')"
                >
                    <app-pie-chart
                        :chart-data="reportData.vehicleEntriesData"
                    />
                </app-monthly-management-report-section>

                <app-monthly-management-report-section
                    :section="getSection('estado-de-correspondencia')"
                >
                    <b-row>
                        <b-col style="margin-left:-90px;">
                            <app-pie-chart :chart-data="reportData.mailsData" />
                        </b-col>
                        <b-col style="margin-left:-90px;">
                            <app-pie-chart
                                :chart-data="reportData.deliveredMailsData"
                            />
                        </b-col>
                    </b-row>
                </app-monthly-management-report-section>
            </div>

            <div class="page-break">
                <app-monthly-management-report-section
                    :section="getSection('historico-visitas')"
                >
                    <app-column-chart
                        :chart-data="reportData.historicalEntries"
                    />
                </app-monthly-management-report-section>
            </div>

            <div class="page-break">
                <app-monthly-management-report-section
                    :section="getSection('anotaciones')"
                >
                    <app-pie-chart :chart-data="reportData.notebookData" />
                </app-monthly-management-report-section>

                <!-- <app-monthly-management-report-section :section="getSection('gestion-interna')">

                    <b-container fluid>
                        <section class="gestion">
                            <b-row>
                                <b-col cols="12">
                                    <span class="font-weight-bold">Gestión</span>
                                </b-col>
                            </b-row>
                            <b-row v-for="management in managements" :key="management.id">
                                <b-col cols="12">
                                    <div class="font-weight-bold">{{ management.name }} ({{ management.management_date | date }})</div>
                                    <div v-html="management.description"></div>
                                </b-col>
                            </b-row>
                        </section>
                        <section class="capacitaciones">
                            <b-row>
                                <b-col cols="12">
                                    <span class="font-weight-bold">Capacitaciones</span>
                                </b-col>
                            </b-row>
                            <b-row v-for="training in trainings" :key="training.id">
                                <b-col cols="12">

                                </b-col>
                            </b-row>
                        </section>
                    </b-container>

                </app-monthly-management-report-section>-->

                <app-monthly-management-report-section
                    :section="getSection('recomendaciones-seguridad')"
                >
                    <b-container fluid>
                        <b-row v-if="!!reportData.safetyRecommendations.length">
                            <b-col cols="12">
                                <article
                                    v-for="(recomendation,
                                    i) in reportData.safetyRecommendations"
                                    :key="recomendation.id"
                                    class="mb-4"
                                >
                                    <b-row>
                                        <b-col cols="12">
                                            {{ i + 1 }} -
                                            {{ recomendation.description }}
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" md="4" lg="3">
                                            <small>
                                                <strong>Fecha:</strong>
                                                <time>
                                                    {{
                                                        recomendation.created_at
                                                            | datetime
                                                    }}
                                                </time>
                                            </small>
                                        </b-col>
                                        <b-col cols="12" md="4" lg="3">
                                            <small>
                                                <strong
                                                    >Recomendado por:</strong
                                                >
                                                {{ recomendation.user.name }}
                                            </small>
                                        </b-col>
                                        <b-col cols="12" md="4" lg="3">
                                            <small>
                                                <strong>Ubicación:</strong>
                                                {{
                                                    recomendation.structure.name
                                                }}
                                            </small>
                                        </b-col>
                                    </b-row>
                                </article>
                            </b-col>
                        </b-row>
                        <b-row v-else>
                            <b-col cols="12"
                                >No hay información para este periodo</b-col
                            >
                        </b-row>
                    </b-container>
                </app-monthly-management-report-section>
            </div>
            <div class="page-break">
                <app-monthly-management-report-section
                    :section="getSection('estado-pqrs')"
                >
                    <b-table
                        v-if="!!reportData.petitionsStates.length"
                        responsive
                        small
                        striped
                        hover
                        :items="reportData.petitionsStates"
                        :fields="fieldsStatePqrs"
                    >
                        <template v-slot:created_at="{ item }">{{
                            item.created_at | datetime
                        }}</template>
                        <!-- <template v-slot:comments="{ item }">
                            <b-row v-for="comment in item.comments" :key="comment.id">
                                <b-col>- {{comment.comment}}</b-col>
                            </b-row>
                        </template> -->
                    </b-table>
                    <b-row v-else>
                        <b-col cols="12"
                            >No hay información para este periodo</b-col
                        >
                    </b-row>
                </app-monthly-management-report-section>
            </div>

            <div class="page-break">
                <app-monthly-management-report-section
                    :section="getSection('reuniones')"
                >
                    <section>
                        <div v-if="reportData.contactReports.length">
                            <article
                                v-for="(report, i) in reportData.contactReports"
                                :key="report.id"
                                class="mb-4"
                            >
                                <b-row>
                                    <b-col cols="6">
                                        <strong
                                            >{{ i + 1 }}) Motivo de la
                                            reunión:</strong
                                        >
                                        {{ report.purpose }}
                                    </b-col>
                                    <b-col cols="6">
                                        La reunión fue llevada a cabo el día y
                                        hora
                                        <time>
                                            {{
                                                report.meeting_date | datetime
                                            }}.
                                        </time>
                                    </b-col>
                                    <b-col cols="12">
                                        <br />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" md="12" lg="12">
                                        <span class="font-weight-bold"
                                            >Descripción de la reunión:</span
                                        >
                                        {{ report.meeting_description }}.
                                    </b-col>
                                    <b-col cols="12">
                                        <br />
                                    </b-col>
                                    <b-col cols="12" md="12" lg="12">
                                        <div
                                            v-if="
                                                report.participants.length > 1
                                            "
                                        >
                                            <span class="font-weight-bold">
                                                Se contó con
                                                {{ report.participants.length }}
                                                participantes, los cuales
                                                fueron:
                                            </span>
                                        </div>
                                        <div
                                            v-if="
                                                report.participants.length === 1
                                            "
                                        >
                                            Se contó con
                                            {{ report.participants.length }}
                                            participante, el cual fue:
                                        </div>
                                        <div v-if="!report.participants.length">
                                            No se conto con participantes.
                                        </div>
                                    </b-col>
                                    <b-col
                                        cols="12"
                                        md="12"
                                        lg="12"
                                        v-if="report.participants.length"
                                    >
                                        <div
                                            v-for="(participant,
                                            i) in report.participants"
                                            :key="i"
                                        >
                                            - {{ participant.name }} ({{
                                                participant.email
                                            }}) - {{ participant.position }}
                                        </div>
                                    </b-col>
                                    <b-col cols="12">
                                        <br />
                                    </b-col>
                                    <b-col cols="12">
                                        <span class="font-weight-bold">
                                            Compromisos de la reunión ({{
                                                report.petitions.length
                                            }}):
                                        </span>
                                    </b-col>
                                    <b-col
                                        cols="12"
                                        v-if="report.petitions.length"
                                    >
                                        <div
                                            v-for="(petition,
                                            i) in report.petitions"
                                            class="mb-3"
                                            :key="i"
                                        >
                                            - ({{
                                                petition.petition_type.name
                                            }}): {{ petition.description }}
                                        </div>
                                    </b-col>
                                    <b-col v-else>Sin compromisos</b-col>
                                </b-row>
                            </article>
                        </div>
                        <div>
                            <article>No hay reuniones en este periodo</article>
                        </div>
                    </section>
                </app-monthly-management-report-section>
            </div>
            <app-monthly-management-report-section
                :section="getSection('gestion-interna')"
            >
                <app-internal-management
                    :management="reportData.internalManagement"
                />
            </app-monthly-management-report-section>
            <div class="page-break">
                <app-monthly-management-report-section
                    :section="getSection('novedades')"
                >
                    <div>
                        <b-row
                            v-for="(annotation,
                            i) in reportData.annotationsWithNews"
                            :key="annotation.id"
                            class="mb-4"
                        >
                            <b-col cols="12">
                                <h6>
                                    {{ i + 1 }} - {{ annotation.user.name }}
                                    <span class="text-muted">
                                        ({{ annotation.created_at | datetime }})
                                    </span>
                                </h6>
                            </b-col>
                            <b-col cols="12">{{ annotation.content }}</b-col>
                            <b-col cols="12">
                                <hr />
                            </b-col>
                        </b-row>
                    </div>
                </app-monthly-management-report-section>
            </div>
        </div>
    </app-page-content>
</template>
<script>
import Filters from './MonthlyManagementReportFilters/MonthlyManagementReportFilters.vue'
import MonthlyManagementReportSection from './MonthlyManagementReportSection/MonthlyManagementReportSection.vue'
import PieChart from '../../Charts/PieChart.vue'
import ColumnChart from '../../Charts/ColumnChart.vue'
import { reportDataProcess } from '../../../../mixin'
import reportingRepository from '../../../../repositories/reporting.repository'
import { mapGetters } from 'vuex'
import InternalManagement from './InternalManagement/InternalManagement.vue'

export default {
    components: {
        appFilters: Filters,
        appMonthlyManagementReportSection: MonthlyManagementReportSection,
        appPieChart: PieChart,
        appColumnChart: ColumnChart,
        appInternalManagement: InternalManagement,
    },
    mixins: [reportDataProcess],
    data() {
        return {
            reportData: {
                personEntriesData: [],
                vehicleEntriesData: [],
                mailsData: [],
                deliveredMailsData: [],
                top10StructuresByVisitors: [],
                historicalEntries: [],
                internalManagement: [],
                notebookData: [],
                safetyRecommendations: [],
                petitionsStates: [],
                contactReports: [],
                annotationsWithNews: [],
            },
            clientCity: null,
            reportSections: [],
            selectedFilters: {
                clientId: '',
                year: '',
                month: '',
            },
            fieldsStatePqrs,
        }
    },
    watch: {
        ['selectedFilters.clientId'](val) {
            this.clearReportData()
            this.reportSections = []
        },
        ['selectedFilters.year'](val) {
            this.clearReportData()
            this.reportSections = []
        },
        ['selectedFilters.month'](val) {
            this.clearReportData()
            this.reportSections = []
        },
        selectedClient(val) {
            if (!val) return
            this.loadClientCity(val.id)
        },
    },
    computed: {
        ...mapGetters(['clients', 'months']),
        selectedClient() {
            return this.clients.find(
                client => client.id === this.selectedFilters.clientId
            )
        },
        selectedMonth() {
            return this.months.find(
                month => month.id === this.selectedFilters.month
            )
        },
        currentDate() {
            return moment().format('LL')
        },
        managements() {
            if (!this.reportData.internalManagement) return []

            return this.reportData.internalManagement.filter(
                item => item.internal_management_type.slug === 'gestion'
            )
        },
        trainings() {
            if (!this.reportData.internalManagement) return []

            return this.reportData.internalManagement.filter(
                item => item.internal_management_type.slug === 'capacitaciones'
            )
        },
    },
    methods: {
        async loadClientCity(clientId) {
            const { data } = await repo.get(`clients/${clientId}/city`)
            this.clientCity = data
        },
        clearReportData() {
            Object.keys(this.reportData).map(key => (this.reportData[key] = []))
        },
        async loadReportData(params) {
            this.selectedFilters = params

            try {
                const rr = { ...reportingRepository }
                const filters = {
                    client: params.clientId,
                    year: params.year,
                    month: params.month,
                }

                const { data } = await rr.getManagementReportData(filters)

                this.reportData.personEntriesData = this.processPersonEntryData(
                    data.personEntries
                )
                this.reportData.vehicleEntriesData = this.processVehicleEntryData(
                    data.vehicleEntries
                )
                this.reportData.mailsData = this.processMailData(data.mails)
                this.reportData.deliveredMailsData = this.processDeliveredMailsData(
                    data.deliveredMails
                )
                this.reportData.top10StructuresByVisitors = this.processTop10StructuresByVisitors(
                    data.top10StructuresByVisitors
                )
                this.reportData.historicalEntries = this.processHistoricalEntries(
                    data.historicalEntries
                )
                this.reportData.internalManagement = data.internalManagement
                this.reportSections = data.reportSections
                this.reportData.notebookData = this.processNotebookData(
                    data.notebook
                )
                this.reportData.petitionsStates = data.petitionsStates
                this.reportData.safetyRecommendations =
                    data.safetyRecommendations
                this.reportData.contactReports = data.contactReports
                this.reportData.annotationsWithNews = data.annotations
            } catch (err) {
                toastr.error(
                    `Ocurrió un error cargando los datos [${err.message}]`
                )
            }
        },
        getSection(slug) {
            const tmpSection = this.reportSections.find(
                section => section.slug === slug
            )

            if (!tmpSection) return null
            // Reemplazar valores dinamicos
            const section = {
                ...tmpSection,
                name: this.replaceVars(tmpSection.name),
                description: this.replaceVars(tmpSection.description),
            }
            return section
        },
        replaceVars(text) {
            return text
                .replace('{{ client }}', this.selectedClient.name)
                .replace('{{ month }}', this.selectedMonth.name)
                .replace('{{ year }}', this.selectedFilters.year)
        },
    },

    created() {
        this.load('clients')
        this.load('months')
    },
}

const fieldsStatePqrs = [
    {
        key: 'created_at',
        label: 'Fecha creación',
    },
    {
        key: 'petition_status.name',
        label: 'Estado de la PQR',
    },
    {
        key: 'petition_type.name',
        label: 'Tipo de PQR',
    },
    {
        key: 'description',
        label: 'Descripción',
    },
]
</script>
<style lang="scss">
.location-date {
    font-size: 1.5rem;

    &__client {
        font-weight: bold;
    }
}

@media print {
    .page-break {
        display: block;
        page-break-before: always;
        margin-top: 100px;
    }
}
</style>
